import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

const badge = cva(
	"inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-medium whitespace-nowrap",
	{
		variants: {
			variant: {
				solid: "bg-ink text-canvas",
				outline: "border border-line-strong text-ink-muted",
				quiet: "bg-raised text-ink-muted",
				alert: "border border-alert-line bg-alert-soft text-alert",
			},
		},
		defaultVariants: { variant: "quiet" },
	},
);

type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badge>;

export const Badge = ({ className, variant, ...props }: BadgeProps) => (
	<span className={cn(badge({ variant }), className)} {...props} />
);
